import React from 'react';
import logo from './logo.svg';
import { Router } from './Router';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import { ModalsProvider } from '@mantine/modals';
import { RefererProvider } from './providers/RefererProvider';

import './App.css';

function App() {

  return (
    <>
    <MantineProvider >
      <ModalsProvider>
        <RefererProvider>
          <div id="main-body" style={{color: "#03034F"}}>
            <Router />
          </div>
        </RefererProvider>
      </ModalsProvider>
    </MantineProvider>
    </>
  )
}
export default App;
